module.exports = __webpack_public_path__ + "img/draft.65758c19.png";